import SearchBar from "./components/SearchBar.jsx";
import './App.css';

function App() {
  return (
    <div className="App">
        <SearchBar />
    </div>
  );
}

export default App;
